import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // 3秒後に要素を削除
    setTimeout(() => {
      this.element.remove()
    }, 3000)
  }
}
